var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axiosInstance from '../../store/AxiosSingleton';
import { MembreImageProfil } from 'membre/classes/MembreImageProfil.class';
import { MembrePrive } from 'membre/classes/MembrePrive.class';
import { MembrePublic } from 'membre/classes/MembrePublic.class';
import { MembreSituation } from 'membre/classes/MembreSituation.class';
import { Membre } from 'membre/classes/Membre.class';
export class MembreService {
    /**
     * Récupère le membre avec l'id correspondant
     * @param idMembre Identifiant du membre à récupérer
     * @return Membre correspondant à l'identifiant
     */
    static loadMember(idMembre) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: MembreService.rubModule,
                    action: 'LOAD_MEMBER',
                    idMembre,
                },
            });
            return new Membre(content.infoPublic, (_a = content.infoPrive) !== null && _a !== void 0 ? _a : null);
        });
    }
    /**
     * Charge les membres en fonction des filtres reçu
     * @param request Objet contenant les filtres à appliquer
     * @see RequestBackAllMember
     */
    static loadMembers(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: MembreService.rubModule, action: 'LOAD_MEMBERS' }, request),
            });
            return {
                membres: content.membres.map((membre) => new Membre(membre.infoPublic)),
                amount: content.amount,
            };
        });
    }
    /**
     * Charge les membres avec un pseudonyme correspondant
     * @param {LoadMemberAutoComplete} request objet attribut pseudo correspondant à la recherche par pseudo, exact à true si l'on souhaite faire la recherche EXACTEMENT sur le pseudo
     */
    static loadMembersAutoComplete(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: MembreService.rubModule, action: 'LOAD_MEMBER_AUTOCOMPLETE' }, request),
            });
            return content.map((membre) => new Membre(membre === null || membre === void 0 ? void 0 : membre.infoPublic));
        });
    }
    /**
     * Connecte un utilisateur en fonction de son mail et de son mot de passe
     * @param {LoadMemberAutoComplete} loginRequest Objet contenant le mail, le mot de passe de l'utilisateur et s'il souhaite rester connecté
     * @return Membre connecté
     */
    static connect(loginRequest) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: MembreService.rubModule, action: 'CONNECT_MEMBER' }, loginRequest),
            });
            return {
                membre: content.membre === undefined ? null : new Membre(content.membre.infoPublic, content.membre.infoPrive),
                mail: ((_a = content.mail) === null || _a === void 0 ? void 0 : _a.length) > 0 ? content.mail : null,
            };
        });
    }
    /**
     * Charge les contacts d'un membre
     * @param {LoadContactsRequest} loadRequest Filtres à appliquer
     * @return Liste des contacts
     */
    static loadContacts(loadRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: MembreService.rubModule, action: 'LOAD_CONTACTS' }, loadRequest),
            });
            return {
                membres: content.membres.map((membre) => new Membre(membre.infoPublic)),
                total: content.total,
            };
        });
    }
    /**
     * Déconnecte l'utilisateur connecté
     * @return True si l'utilisateur a été déconnecté
     */
    static disconnectMember() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { success }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: MembreService.rubModule,
                    action: 'DISCONNECT_MEMBER',
                },
            });
            return success;
        });
    }
    /**
     * Envoi un mail à un utilisateur ayant perdu le mot de passe de son compte
     * @param mail adresse mail de l'utilisateur ayant oublié son mot de passe
     * @return l'adresse mail si le compte n'est pas validé, null sinon
     */
    static sendMailForgotPassword(mail) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { mail }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'SEND_MAIL_PASSWORD_FORGOT',
                },
            });
            return content;
        });
    }
    /**
     * Connecte un utilisateur en fonction de son mail et du mot de passé généré aléatoirement
     * @param mail adresse mail hashé de l'utilisateur
     * @param password mot de passé hashé généré aléatoirement
     * @return True si action réussie, false sinon
     */
    static connectForgotPassword(request) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(request === null || request === void 0 ? void 0 : request.mail) || !(request === null || request === void 0 ? void 0 : request.password)) {
                return null;
            }
            const { data: { content }, } = yield axiosInstance.post('/index.php', Object.assign({}, request), {
                params: {
                    rub: MembreService.rubModule,
                    action: 'CONNECT_PASSWORD_FORGOT',
                },
            });
            return new Membre(content.infoPublic, content.infoPrive);
        });
    }
    /**
     * Change le mot de passe d'un utilisateur qui a perdu son mot de passe
     * @param idMembre identifiant du membre qui à perdu son mot de passe
     * @param motDePasse nouveau mot de passe de l'utilisateur
     * @return True si action réussie, false sinon
     */
    static changeForgotPassword(idMembre, motDePasse) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!idMembre || !motDePasse) {
                return false;
            }
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idMembre, motDePasse }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'CHANGE_PASSWORD_FORGOT',
                },
            });
            return content;
        });
    }
    /**
     * Change le mot de passe de l'utilisateur dans la base de données
     * @param oldPassword Ancien mot de passe
     * @param newPassword Nouveau mot de passe
     * @return True si le mot de passe a été changé, false sinon
     */
    static changePassword(oldPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { oldPassword, newPassword }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'CHANGE_PASSWORD',
                },
            });
            return content;
        });
    }
    /**
     * Charge la relation de l'utilisateur connecté avec un utilisateur
     * @param idMembre Identifiant du membre dont on veut vérifier la relation
     * @return Relation entre les deux utilisateurs
     */
    static loadContactStatus(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: MembreService.rubModule,
                    action: 'LOAD_CONTACT_STATUS',
                    idMembre,
                },
            });
            return content;
        });
    }
    /**
     * Charge les membres bloqués par un utilisateur
     * @param request Filtres à appliquer
     * @return Membres bloqués et nombre total des membres bloqués
     */
    static loadBlocages(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: MembreService.rubModule, action: 'LOAD_BLOCAGES' }, request),
            });
            return {
                membres: content.membres.map((bloque) => new Membre(bloque.infoPublic)),
                total: content.total,
            };
        });
    }
    /**
     * Récupère les avatars d'un membre
     * @param idMembre identifiant du membre dont on récupère tous les avatars
     * @return Liste des avatars d'un membre
     */
    static loadAllAvatars(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: MembreService.rubModule,
                    action: 'LOAD_ALL_AVATARS',
                    idMembre,
                },
            });
            return content.map((img) => new MembreImageProfil(img));
        });
    }
    /**
     * Supprime en bdd l'avatar de l'utilisateur
     * @param idAvatar id de l'avatar à supprimer
     * @param isSame true si l'avatar à supprimer est le même que l'avatar courant de l'utilisateur
     * @return true si succès
     */
    static deleteAvatar(imageProfil) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: MembreService.rubModule,
                    action: 'DELETE_AVATAR',
                    imageProfil: imageProfil.toRaw(),
                },
            });
            return {
                membrePublic: new MembrePublic(content.membre.infoPublic),
                imagesProfil: content.imagesProfil.map((image) => new MembreImageProfil(image)),
            };
        });
    }
    /**
     * Sauvegarde une nouvelle image de profil
     * @param imageProfil Image de profil à sauvegarder
     * @return L'image de profil qui vient d'être sauvegardée
     */
    static saveAvatar(imageProfil) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { imageProfil: imageProfil.toRaw() }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'SAVE_AVATAR',
                },
            });
            return new MembreImageProfil(content);
        });
    }
    /**
     * Vérifie la validité du pseudo
     * @param pseudo Pseudo à vérifier
     * @return True si le pseudo est valide
     */
    static lookupPseudo(pseudo) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: MembreService.rubModule,
                    action: 'LOOKUP_PSEUDO',
                    pseudo,
                },
            });
            return content;
        });
    }
    /**
     * Vérifie la validité d'un mail
     * @param mail Mail à vérifier
     * @return True si le mail est valide
     */
    static lookupMail(mail) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: MembreService.rubModule,
                    action: 'LOOKUP_MAIL',
                    mail,
                },
            });
            return content;
        });
    }
    /**
     * Valide le mail d'un utilisateur
     * @param {ValidateRequest} info Mail où a été envoyé le code de validation et code de validation envoyé par l'utilisateur
     * @return True si le code de validation est valide
     */
    static validateMember(info) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', Object.assign({}, info), {
                params: {
                    rub: MembreService.rubModule,
                    action: 'VALIDATE_MEMBER',
                },
            });
            return content;
        });
    }
    /**
     * Sauvegarde un membre en base de données
     * @param membre Membre à sauvegarder
     * @return True s'il a été sauvegardé
     */
    static saveMember(membre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { membre: membre.toRaw() }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'SAVE_MEMBER',
                },
            });
            return content;
        });
    }
    /**
     * Si le paramètre est renseigné on envoie un mail à `mail`
     * Sinon envoie un mail à l'adresse mail contenu dans le champ `tempMail` de l'utilisateur
     * @param mail *(optionnel)* Mail auquel on envoie le nouveau code
     * @return true si l'action est réussite
     */
    static sendNewCode(mail) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { mail }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'SEND_NEW_CODE',
                },
            });
            return content;
        });
    }
    /**
     * Effectue une requete pour modifier l'adresse mail de l'utilisateur
     * @param mail Nouvelle adresse mail
     * @return le mail temporaire inséré
     */
    static changeMail(mail) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { mail }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'CHANGE_MAIL',
                },
            });
            return content;
        });
    }
    /**
     * Annule la demande de modification de mail
     * @description Défini tempMail et verifMail à null en bdd pour l'utilisateur
     * @return true si action réussi
     */
    static cancelMail() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {}, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'CANCEL_CHANGE_MAIL',
                },
            });
            return new MembrePrive(content);
        });
    }
    /**
     * Bloque un utilisateur
     * @param idMembre Identifiant de l'utilisateur
     * @return L'objet membre de l'utilisateur bloqué
     */
    static blockContact(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idMembre }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'BLOCK_CONTACT',
                },
            });
            return new Membre(content.infoPublic);
        });
    }
    /**
     * Débloque un utilisateur
     * @param idBloqueur Identifiant de la personne à débloquer
     * @return L'objet membre de l'utilisateur bloqué
     */
    static unblockContact(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: MembreService.rubModule,
                    action: 'UNBLOCK_CONTACT',
                    idMembre,
                },
            });
            return new Membre(content.infoPublic);
        });
    }
    /**
     * Charge l'utilisateur courant
     * @return Membre courant
     */
    static loadCurrent() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: MembreService.rubModule,
                    action: 'LOAD_CURRENT',
                },
            });
            if (!content) {
                return null;
            }
            return new Membre(content.infoPublic, content.infoPrive);
        });
    }
    /**
     * Charge le nombre total d'utilisateurs
     * @param {LoadTotalAmountOfMembersRequest} filter Filtre à appliquer
     * @return Nombre total d'utilisateurs
     */
    static loadTotalAmountOfMembers(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: MembreService.rubModule,
                    action: 'LOAD_TOTAL_AMOUNT_MEMBERS',
                    filter,
                },
            });
            return content;
        });
    }
    /**
     * Charge toutes les situations
     * @return Liste des situations
     */
    static loadAllSituations() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: MembreService.rubModule,
                    action: 'LOAD_ALL_SITUATIONS',
                },
            });
            return content.map((situation) => new MembreSituation(situation));
        });
    }
    /**
     * Récupère l'identifiant membre le plus élevé
     * @return L'identifiant membre
     */
    static loadMaxIdMembre() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: MembreService.rubModule,
                    action: 'LOAD_MAX_ID_MEMBRE',
                },
            });
            return content;
        });
    }
    /**
     * Change les données publiques du membre
     * @param objet les données à mettre à jour
     * @return true si action réussie, false sinon
     */
    static editPublicData(membre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                membre: membre.toRaw(),
            }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'EDIT_PUBLIC_DATA',
                },
            });
            return new MembrePublic(content.infoPublic);
        });
    }
    /**
     * Change les données privées du membre
     * @param objet valeur des données privées à mettre à jour.
     * @param idMembre identifiant du membre
     * @return true si action réussie
     */
    static editPrivateData(membrePrive, idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                membre: membrePrive.toRaw(),
                idMembre,
            }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'EDIT_PRIVATE_DATA',
                },
            });
            return new MembrePrive(content.infoPrive);
        });
    }
    /**
     * Change les données de présentation d'un membre
     * @param objet objet à insérer.
     * @param idMembre identifiant du membre à éditer
     * @return true si action réussie, false sinon.
     */
    static editPresentationData(membrePresentation, idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                membrePresentation: membrePresentation.toRaw(),
                idMembre,
            }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'EDIT_PRESENTATION_DATA',
                },
            });
            return content;
        });
    }
    /**
     * Met à jour un paramètre d'un utilisateur
     * @param notification Un paramètre de notification du membre
     * @return Les données privé de l'utilisateur
     */
    static editParameters(notification) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                notification,
            }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'EDIT_PARAMETERS',
                },
            });
            return new MembrePrive(content);
        });
    }
    /**
     * Change les réseaux sociaux d'un membre
     * @param facebook lien facebook
     * @param twitter lien twitter
     * @param linkedin lien linkedin
     * @param instagram lien instagram
     * @param pinterest lien pinterest
     * @param snapchat lien snapchat
     * @param twitch lien twitch
     * @param youtube lien youtube
     * @return true si action réussie, false sinon
     */
    static editSocialNetworksData(facebook, twitter, linkedin, instagram, pinterest, snapchat, twitch, youtube) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', 
            // TODO: Faire un objet avec tous les réseaux sociaux
            { facebook, twitter, linkedin, instagram, pinterest, snapchat, twitch, youtube }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'EDIT_SOCIAL_NETWORKS_DATA',
                },
            });
            return content;
        });
    }
    /**
     * Charge le nombre de membres non-modérés
     * @return Nombre de membres non-modérés
     */
    static loadUnmoderatedMemberAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: MembreService.rubModule,
                    action: 'LOAD_UNMODERATED_MEMBER_AMOUNT',
                },
            });
            return content;
        });
    }
    /**
     * Rend muet les notifications du contact pour l'utilisateur connecté
     * @param idContact Identifiant du contact
     * @return L'objet membre du contact
     */
    static muteContact(idContact) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idContact }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'MUTE_CONTACT',
                },
            });
            return new Membre(content.infoPublic);
        });
    }
    /**
     * Réactive les notifications du contact pour l'utilisateur connecté
     * @param idContact Identifiant du contact
     * @return L'objet membre du contact
     */
    static unmuteContact(idContact) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: MembreService.rubModule,
                    action: 'UNMUTE_CONTACT',
                    idContact,
                },
            });
            return new Membre(content.infoPublic);
        });
    }
    /**
     * Insère une demande de suppression de compte dans la table membreDemandeSuppression
     * @param demandeSuppression Données à insérer en BDD
     * @return true si action réussie, false sinon.
     */
    static deleteAccount(demandeSuppression) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                demandeSuppression: demandeSuppression.toRaw(),
            }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'DELETE_ACCOUNT',
                },
            });
            return new MembrePrive(content);
        });
    }
    /**
     * Supprime une demande de suppression de compte dans la table membreDemandeSuppression
     * @param idMembre Identifiant du membre
     * @param code Code de vérification
     * @return true si action réussie, false sinon.
     */
    static cancelDeleteAccount(demandeSuppression) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: MembreService.rubModule,
                    action: 'CANCEL_DELETE_ACCOUNT',
                    idMembre: demandeSuppression.idMembre,
                    code: demandeSuppression.verifDemande,
                },
            });
            return new MembrePrive(content);
        });
    }
    /**
     * Verifie la connexion à l'application (remplace le HTACCESS et HTPASSWD)
     * @param identifiant Identifiant de connexion
     * @param motDePasse Mot de passe
     * @return true si action réussie, false sinon.
     */
    static checkHTAccess(identifiant, motDePasse) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                identifiant,
                motDePasse,
            }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'CONNECTION_HTACCESS',
                },
            });
            return content;
        });
    }
    /**
     * Effectue une demande de contact auprès d'un membre
     * @param idMembre Identifiant du membre recevant la demande de contact
     * @return L'objet membre de l'utilisateur recevant la demande de contact
     */
    static addContact(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idMembre }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'ADD_CONTACT',
                },
            });
            return content === null ? null : new Membre(content.infoPublic);
        });
    }
    /**
     * Supprime une demande de contact auprès d'un membre
     * @param idContact Identifiant du membre dont on supprime la demande de contact
     * @return L'objet membre de l'utilisateur où l'on a supprimé la demande de contact
     */
    static removeContact(idContact) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: MembreService.rubModule,
                    action: 'REMOVE_CONTACT',
                    idContact,
                },
            });
            if (!content) {
                return null;
            }
            return {
                contact: new Membre(content.contact.infoPublic),
                current: new Membre(content.current.infoPublic, content.current.infoPrive),
            };
        });
    }
    /**
     * Accepte une demande de contact auprès d'un membre
     * @param idContact Identifiant du membre dont on accepte la demande de contact
     * @return L'objet membre de l'utilisateur on accepte la demande de contact
     */
    static acceptContact(idContact) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idContact }, {
                params: {
                    rub: MembreService.rubModule,
                    action: 'ACCEPT_CONTACT',
                },
            });
            if (!content) {
                return null;
            }
            return {
                contact: new Membre(content.contact.infoPublic),
                current: new Membre(content.current.infoPublic, content.current.infoPrive),
            };
        });
    }
}
MembreService.rubModule = 'membre';
//# sourceMappingURL=data:application/json;base64,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